import { StateUtils } from '@spartacus/core';
import { B2BPermissionOrderListItem, ListModel, Permission, SearchConfig } from '../../../../core/model';
import { PyStateUtils } from '../../../../core/state';
import { serializeSearchConfig } from '../../../../core/state/utils/serializer';
import {
  PERMISSION_BUYER_ENTITIES,
  PERMISSION_BUYER_LIST,
  PERMISSION_BUYER_ORDERS_ENTITIES,
  PERMISSION_BUYER_ORDERS_LIST,
} from '../permission-state';

export const LOAD_BUYER_PERMISSION = '[Permission] Load Buyer Permission Data';
export const LOAD_BUYER_PERMISSION_FAIL = '[Permission] Load Buyer Permission Data Fail';
export const LOAD_BUYER_PERMISSION_SUCCESS = '[Permission] Load Buyer Permission Data Success';

export const LOAD_BUYER_PERMISSIONS = '[Permission] Load Buyer Permissions';
export const LOAD_BUYER_PERMISSIONS_FAIL = '[Permission] Load Buyer Permissions Fail';
export const LOAD_BUYER_PERMISSIONS_SUCCESS = '[Permission] Load Buyer Permissions Success';
export const LOAD_BUYER_PERMISSIONS_RESET = '[Permission] Load Buyer Permissions Reset';

export const LOAD_BUYER_PERMISSION_ORDERS = '[Permission] Load Buyer Permission Orders';
export const LOAD_BUYER_PERMISSION_ORDERS_FAIL = '[Permission] Load Buyer Permission Orders Fail';
export const LOAD_BUYER_PERMISSION_ORDERS_SUCCESS = '[Permission] Load Buyer Permission Orders Success';
export const LOAD_BUYER_PERMISSION_ORDERS_RESET = '[Permission] Load Buyer Permission Orders Reset';

export const LOAD_BUYER_PERMISSION_ORDER = '[Permission] Load Buyer Permission Order Data';
export const LOAD_BUYER_PERMISSION_ORDER_FAIL = '[Permission] Load Buyer Permission Order Data Fail';
export const LOAD_BUYER_PERMISSION_ORDER_SUCCESS = '[Permission] Load Buyer Permission Order Data Success';

export class LoadBuyerPermission extends StateUtils.EntityLoadAction {
  readonly type = LOAD_BUYER_PERMISSION;
  constructor(public payload: { userId: string; permissionCode: string }) {
    super(PERMISSION_BUYER_ENTITIES, payload.permissionCode);
  }
}

export class LoadBuyerPermissionFail extends PyStateUtils.EntityFailAction {
  readonly type = LOAD_BUYER_PERMISSION_FAIL;
  constructor(public payload: { permissionCode: string; error: any }) {
    super(PERMISSION_BUYER_ENTITIES, payload.permissionCode, payload.error);
  }
}

export class LoadBuyerPermissionSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_BUYER_PERMISSION_SUCCESS;
  constructor(public payload: Permission | Permission[]) {
    super(PERMISSION_BUYER_ENTITIES, Array.isArray(payload) ? payload.map((permission) => permission?.code) : payload?.code);
  }
}

export class LoadBuyerPermissions extends StateUtils.EntityLoadAction {
  readonly type = LOAD_BUYER_PERMISSIONS;
  constructor(
    public payload: {
      userId: string;
      params: SearchConfig;
    }
  ) {
    super(PERMISSION_BUYER_LIST, serializeSearchConfig(payload.params));
  }
}

export class LoadBuyerPermissionsFail extends PyStateUtils.EntityFailAction {
  readonly type = LOAD_BUYER_PERMISSIONS_FAIL;
  constructor(public payload: { params: SearchConfig; error: any }) {
    super(PERMISSION_BUYER_LIST, serializeSearchConfig(payload.params), payload.error);
  }
}

export class LoadBuyerPermissionsSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_BUYER_PERMISSIONS_SUCCESS;
  constructor(
    public payload: {
      page: ListModel;
      params: SearchConfig;
    }
  ) {
    super(PERMISSION_BUYER_LIST, serializeSearchConfig(payload.params));
  }
}

export class LoadBuyerPermissionsReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_BUYER_PERMISSIONS_RESET;
  constructor(public params?: SearchConfig) {
    super(PERMISSION_BUYER_LIST);
  }
}

export class LoadBuyerPermissionOrders extends StateUtils.EntityLoadAction {
  readonly type = LOAD_BUYER_PERMISSION_ORDERS;
  constructor(
    public payload: {
      userId: string;
      permissionCode: string;
      params: SearchConfig;
    }
  ) {
    super(PERMISSION_BUYER_ORDERS_LIST, serializeSearchConfig(payload.params, payload.permissionCode));
  }
}

export class LoadBuyerPermissionOrdersFail extends PyStateUtils.EntityFailAction {
  readonly type = LOAD_BUYER_PERMISSION_ORDERS_FAIL;
  constructor(public payload: { params: SearchConfig; permissionCode: string; error: any }) {
    super(PERMISSION_BUYER_ORDERS_LIST, serializeSearchConfig(payload.params, payload.permissionCode), payload.error);
  }
}

export class LoadBuyerPermissionOrdersSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_BUYER_PERMISSION_ORDERS_SUCCESS;
  constructor(
    public payload: {
      page: ListModel;
      params: SearchConfig;
      permissionCode: string;
    }
  ) {
    super(PERMISSION_BUYER_ORDERS_LIST, serializeSearchConfig(payload.params, payload.permissionCode));
  }
}

export class LoadBuyerPermissionOrdersReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_BUYER_PERMISSION_ORDERS_RESET;
  constructor(public params?: SearchConfig) {
    super(PERMISSION_BUYER_ORDERS_LIST);
  }
}

export class LoadBuyerPermissionOrder extends StateUtils.EntityLoadAction {
  readonly type = LOAD_BUYER_PERMISSION_ORDER;
  constructor(public payload: { userId: string; permissionCode: string }) {
    super(PERMISSION_BUYER_ORDERS_ENTITIES, payload.permissionCode);
  }
}

export class LoadBuyerPermissionOrderFail extends PyStateUtils.EntityFailAction {
  readonly type = LOAD_BUYER_PERMISSION_ORDER_FAIL;
  constructor(public payload: { permissionCode: string; error: any }) {
    super(PERMISSION_BUYER_ORDERS_ENTITIES, payload.permissionCode, payload.error);
  }
}

export class LoadBuyerPermissionOrderSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_BUYER_PERMISSION_ORDER_SUCCESS;
  constructor(public payload: B2BPermissionOrderListItem | B2BPermissionOrderListItem[]) {
    super(
      PERMISSION_BUYER_ORDERS_ENTITIES,
      Array.isArray(payload) ? payload.map((permissionOrder) => permissionOrder?.orderNumber) : payload?.orderNumber
    );
  }
}

export type PermissionAction =
  | LoadBuyerPermission
  | LoadBuyerPermissionFail
  | LoadBuyerPermissionSuccess
  | LoadBuyerPermissions
  | LoadBuyerPermissionsFail
  | LoadBuyerPermissionsSuccess
  | LoadBuyerPermissionOrders
  | LoadBuyerPermissionOrdersFail
  | LoadBuyerPermissionOrdersSuccess
  | LoadBuyerPermissionOrdersReset
  | LoadBuyerPermissionOrder
  | LoadBuyerPermissionOrderFail
  | LoadBuyerPermissionOrderSuccess;
